import { render, staticRenderFns } from "./PlaceholderImage.vue?vue&type=template&id=76c894b0&"
import script from "./PlaceholderImage.vue?vue&type=script&lang=js&"
export * from "./PlaceholderImage.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports